<template>
  <div>
    <svg class="bg-transparent" width="100%" height="100%" viewBox="-1 -1 2 2" style="transform: rotate(-90deg)">
      <path v-for="(segment, index) in segments" :key="index"
        :d="`M ${segment.startX} ${segment.startY} A 1 1 0 ${segment.largeArcFlag} 1 ${segment.endX} ${segment.endY} L 0 0`"
        :fill="segment.fill">
      </path>
    </svg>
  </div>
</template>

<script>
import { colors, colorsCount } from '@/plugins/colors.js'

export default {
  props: {
    series: {
      type: Array,
      default: () => { return [] }
    }
  },
  computed: {
    total () {
      return this.series.reduce((sum, { value }) => {
        return sum + value
      }, 0)
    },
    segments () {
      const total = this.total
      let cumulativePercent = 0
      const self = this

      const segments = this.series.map(({ value, style }, index) => {
        const percent = value / total

        const [startX, startY] = self.getCoordinatesForPercent(cumulativePercent)

        // each segment starts where the last segment ended, so keep a cumulative percent
        cumulativePercent += percent

        const [endX, endY] = self.getCoordinatesForPercent(cumulativePercent)

        // if the segment is more than 50%, take the large arc (the long way around)
        const largeArcFlag = percent > 0.5 ? 1 : 0

        return {
          startX,
          startY,
          largeArcFlag,
          endX,
          endY,
          fill: style?.color !== undefined ? style?.color : colors[index % colorsCount]
        }
      })

      return segments
    }
  },
  methods: {
    getCoordinatesForPercent (percent) {
      const x = Math.cos(2 * Math.PI * percent)
      const y = Math.sin(2 * Math.PI * percent)
      return [x, y]
    }
  }
}
</script>
